/* eslint-disable */
const spacename = 'SDKBANK';
export const CHANGE_TABLE_DATA = `${spacename}CHANGE_TABLE_DATA`;
export const EDIT_VISIBLE = `${spacename}EDIT_VISIBLE`;
